<template>
  <div class="market_analysis">
    <div class="main_content">
      <!-- 分析类型 -->
      <div class="analysis_type">
        <div class="title"><span class="line"></span>分析类型：</div>
        <el-radio-group v-model="type.analysisType" @change="selectType">
          <el-radio label="0">汇总效果</el-radio>
          <el-radio label="1"
            >指定任务:
            <el-select
              :disabled="typeView"
              @change="taskAppoint"
              v-model="type.remindConfigId"
              placeholder="请选择"
              style="margin-left: 6px"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-radio>
        </el-radio-group>
      </div>
      <!-- 今日数据监控 -->
      <div class="data_today" v-loading="todayLoading">
        <div class="title"><span class="line"></span>今日数据监控</div>
        <div>
          <div
            v-for="(item, index) in todayData"
            :key="index"
            class="today_item"
          >
            <div class="data_name">
              {{ item.name }}
              <el-tooltip
                class="item"
                effect="light"
                :content="roiTip"
                placement="top-start"
                v-if="index == 5"
              >
                <span class="question_icon">?</span>
              </el-tooltip>
            </div>
            <div class="data_num">
              {{ item.data }}
              <span class="data_num_unit">{{ item.unit }}</span>
            </div>
            <div
              class="edit_price"
              v-if="index == 5"
              @click="unitPriceView = true"
            >
              修改单价
            </div>
          </div>
        </div>
      </div>
      <div class="data_old_day">
        <div class="title"><span class="line"></span>往日数据监控</div>
        <div style="overflow: hidden; line-height: 32px; margin-top: 20px">
          <div style="float: left">
            <el-radio-group
              v-model="rangeCountParams.dataType"
              @change="selectTimeRange"
            >
              <el-radio label="1" class="marginRight_50">近七天</el-radio>
              <el-radio label="2" class="marginRight_50">近一个月</el-radio>
              <el-radio label="3">
                <span style="margin-right: 3px">自定义:</span>
                <div class="my_select_time">
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="rangeCountParams.customTimeStart"
                    type="date"
                    placeholder="选择日期时间"
                    :disabled="timeRangeView"
                    :picker-options="pickerOptions0"
                    size="small"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 120px; margin-left: 8px; font-size: 12px"
                    class="time1"
                    :clearable="false"
                  ></el-date-picker>
                  <div
                    class="time_to_text"
                    :class="{ to_text_disabled: timeRangeView }"
                  >
                    至
                  </div>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="rangeCountParams.customTimeEnd"
                    type="date"
                    placeholder="选择日期时间"
                    :disabled="timeRangeView"
                    :picker-options="pickerOptions1"
                    size="small"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 145px; font-size: 12px"
                    class="time2"
                    :clearable="false"
                  ></el-date-picker>
                  <i
                    class="el-icon-circle-close date_icon1"
                    @click="clearTime"
                  ></i>
                  <img
                    src="@/assets/images/select_date.svg"
                    alt
                    class="date_icon2"
                  />
                </div>
              </el-radio>
            </el-radio-group>
          </div>
          <el-button
            icon="el-icon-search"
            class="status_btn status_btn3"
            @click="seacherResultCare"
            :disabled="talbeLoading"
            >查询</el-button
          >
          <el-button class="status_btn status_btn4" @click="resetBtn"
            >重置</el-button
          >
        </div>
        <!-- 表格 -->
        <div class="tab_box" style="margin-top: 20px">
          <el-table
            v-loading="talbeLoading"
            ref="multipleTable"
            :data="rangeCountList"
            tooltip-effect="light"
            :header-cell-style="{ background: '#fafafa', border: '0px' }"
            style="width: 100%"
            :default-sort="{ prop: 'countTime', order: 'descending' }"
          >
            <template slot="empty">
              <div>
                <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column
              prop="countTime"
              sortable
              label="统计时间"
            ></el-table-column>
            <el-table-column label="发送短信数">
              <template slot-scope="scope">
                <span>{{ scope.row.sendSmsCount }}</span>
              </template>
            </el-table-column>
            <el-table-column label="下单数">
              <template slot-scope="scope">
                <span>{{ scope.row.orderCount }}</span>
              </template>
            </el-table-column>
            <el-table-column label="成交订单数">
              <template slot-scope="scope">
                <span
                  @click="returnOrderNum(scope.row, 1)"
                  :style="{ color: changeColor, cursor: 'pointer' }"
                  >{{ scope.row.dealOrderCount }}单</span
                >
              </template>
            </el-table-column>
            <el-table-column label="成交金额">
              <template slot-scope="scope">
                <span>{{ scope.row.dealAmount }}元</span>
              </template>
            </el-table-column>
            <el-table-column label="营销成功率">
              <template slot-scope="scope">
                <!-- <span>{{ scope.row.successRate }}</span> -->
                <span>{{ scope.row.successRate | toPercentSign}}</span>
              </template>
            </el-table-column>
            <el-table-column label="ROI">
              <template slot="header">
                <div class="roi">
                  <span style="margin-right: 4px">ROI</span>
                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="roiTip"
                    placement="top-start"
                  >
                    <!-- :content="'投入：产出=短信成功扣费条数x短信单价（按'+unitPriceValue+'元算）：挽回金额（例如ROI=1:2相当于花一块钱带来两块钱的收益）'" -->
                    <span
                      class="question_icon"
                      :style="{
                        color: changeColor,
                        border: '1px solid ' + changeColor,
                      }"
                      >?</span
                    >
                  </el-tooltip>
                </div>
              </template>
              <template slot-scope="scope">
                <div>{{ scope.row.roi }}</div>
              </template>
            </el-table-column>
            <!-- 表格-均值 -->
            <div
              class="table-bottom"
              slot="append"
              style="width: 100%; border: 1px solid #eaeaea"
              v-if="JSON.stringify(calculateCuifuAvg) !== '{}'"
            >
              <el-table
                ref="multipleTable"
                :header-cell-style="{
                  background: '#fafafa',
                  'font-weight': 'normal',
                }"
                style="width: 100%"
              >
                <el-table-column label="统计时间">
                  <template slot="header">
                    <div class="special-two" :style="{ color: changeColor }">
                      均值
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="发送短信数">
                  <template slot="header">
                    <div class="special-two">
                      {{ calculateCuifuAvg.sendSmsCount }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="下单数">
                  <template slot="header">
                    <div class="special-two">
                      {{ calculateCuifuAvg.orderCount }}单
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="成交订单数">
                  <template slot="header">
                    <div class="special-two" :style="{ color: changeColor }">
                      {{ calculateCuifuAvg.dealOrderCount }}单
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="成交金额">
                  <template slot="header">
                    <div class="special-two">
                      {{ calculateCuifuAvg.dealAmount || "0.00" }}元
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="lv" label="催付成功率">
                  <template slot="header">
                    <div class="special-two">
                      {{ calculateCuifuAvg.successRate }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="ROI">
                  <template slot="header" slot-scope="scope">
                    <div class="special-two">{{ calculateCuifuAvg.roi }}</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 表格-汇总 -->
            <div
              class="table-bottom"
              slot="append"
              v-if="JSON.stringify(summaryDto) !== '{}'"
            >
              <el-table
                ref="multipleTable"
                :header-cell-style="{
                  background: '#FAFAFA',
                  'font-weight': 'normal',
                }"
                style="width: 100%"
              >
                <el-table-column label="统计时间">
                  <template slot="header">
                    <div class="special-two" :style="{ color: changeColor }">
                      汇总
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="发送短信数">
                  <template slot="header">
                    <div class="special-two">{{ summaryDto.sendSmsCount }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="下单数">
                  <template slot="header">
                    <div class="special-two">{{ summaryDto.orderCount }}单</div>
                  </template>
                </el-table-column>
                <el-table-column label="成交订单数">
                  <template slot="header">
                    <div
                      @click="returnOrderNum({}, 2)"
                      class="special-two"
                      :style="{ color: changeColor }"
                      style="cursor: pointer"
                    >
                      {{ summaryDto.dealOrderCount }}单
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="成交金额">
                  <template slot="header">
                    <div class="special-two">{{ summaryDto.dealAmount }}元</div>
                  </template>
                </el-table-column>
                <el-table-column label="营销成功率">
                  <template slot="header">
                    <div class="special-two">{{ summaryDto.successRate }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="ROI">
                  <template slot="header">
                    <div class="special-two">{{ summaryDto.roi }}</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 挽回订单数弹框 -->
    <el-dialog
      :title="returnOrderTitle"
      :visible.sync="returnOrderDialog"
      width="1100px"
    >
      <div class="return-order-com">
        <div class="up-date">
          <!-- <span>更新时间 :</span>
              {{returnItem.subTime}} -->
        </div>
        <div class="return-order-table" style="margin-top: 20px">
          <el-table
            :data="orderData"
            v-loading="orderLoading"
            :header-cell-style="{ background: '#FAFAFA' }"
            style="width: 100%; border: 1px solid #eaeaea"
          >
            <el-table-column label="买家昵称">
              <template slot="header">
                <div>买家昵称</div>
              </template>
              <template slot-scope="scope">{{ scope.row.pin }}</template>
            </el-table-column>
            <el-table-column label="买家号码">
              <template slot="header">
                <div>手机号码</div>
              </template>
              <template slot-scope="scope">{{ scope.row.mobile }}</template>
            </el-table-column>

            <el-table-column label="实付金额(元)">
              <template slot-scope="scope">{{
                scope.row.orderPayment
              }}</template>
            </el-table-column>

            <el-table-column label="付款时间" class="special">
              <template slot="header">
                <div>付款时间</div>
              </template>
              <template slot-scope="scope">
                <span>{{ scope.row.paymentConfirmTime }}</span>
              </template>
            </el-table-column>

            <el-table-column class="special" width="250">
              <template slot="header" slot-scope="scope">
                <span>短信内容</span>
                <span
                  @click="isShowTextAll"
                  :style="{ color: changeColor }"
                  style="padding-left: 10px; cursor: pointer"
                  >{{ isShowAll ? "单行显示" : "展开全部" }}</span
                >
              </template>
              <template slot-scope="scope">{{
                scope.row.content | overFloatContent(isShowAll)
              }}</template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page" style="margin: 20px 0 10px 0; height: 32px">
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :page-size="pageSize"
            :current-page="pageNum"
            style="float: right"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- 折线图 -->
    <div class="my_chart">
      <div id="myChart" :style="{ width: '100%', height: '430px' }"></div>
    </div>
    <!--修改单价弹窗-->
    <el-dialog title="修改单价" :visible.sync="unitPriceView" width="30%">
      <div>
        <el-input
          type="number"
          v-model="unitPriceValue"
          clearable
          style="width: 90%"
        ></el-input>
        <span style="width: 10%">元/条</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="unitPriceView = false">取 消</el-button>
        <el-button type="primary" @click="updateUnitPrice">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { updateUnitPrice } from "@/api/sellerController";
import { page, data, orderQuery } from "@/api/care/orderCare";
import Pagination from "@/components/pagination.vue";
import returnOrderCom from "../chidrenCare/return-order-com.vue";
import { getSellerInfo } from "@/api/sellerController";

import { mapState } from "vuex";
export default {
  props: {
    selectIndex: {
      type: Number,
    },
  },
  components: {
    Pagination,
    returnOrderCom,
  },
  data() {
    return {
      type: {
        analysisType: "0",
        remindConfigId: "",
      },
      // 是否禁用日期组件
      timeRangeView: true,
      // 是否禁用指定任务下拉框
      typeView: true,
      // 往日数据日期
      rangeCountParams: {
        dataType: "2",
        customTimeStart: "",
        customTimeEnd: "",
      },
      unitPriceValue: 0,
      talbeLoading: false,
      todayLoading: false,
      orderLoading: false,
      myChart: null, //可视化图表实例
      currentComponent: returnOrderCom,
      returnOrderDialog: false, //挽回订单数弹框
      reload: true, //刷新组件
      returnItem: "",
      returnOrderTitle: "成交订单数",
      pickerOptions0: {
        disabledDate: (time) => {
          if (!this.rangeCountParams.customTimeEnd) {
            return time.getTime() > Date.now() - 8.64e7;
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          if (!this.rangeCountParams.customTimeStart) {
            return time.getTime() > Date.now() - 8.64e7;
          } else {
            let startTime = new Date(
              this.rangeCountParams.customTimeStart
            ).getTime();
            // 最大选择时间  （时间跨度不能大于一年）
            let maxTime = startTime + 365 * 24 * 3600 * 1000;

            return (
              time.getTime() < startTime ||
              time.getTime() > Date.now() - 8.64e7 ||
              time.getTime() > maxTime - 8.64e7
            );
          }
        },
      },
      options: [],
      orderData: [],
      todayData: [
        {
          name: "发送短信数",
          data: "",
          unit: "条",
          key: "sendSmsCount",
        },
        {
          name: "下单数",
          data: "",
          unit: "人",
          key: "orderCount",
        },
        {
          name: "成交订单数",
          data: "",
          unit: "单",
          key: "dealOrderCount",
        },
        {
          name: "成交金额",
          data: "",
          unit: "元",
          key: "dealAmount",
        },
        {
          name: "营销成功率",
          data: "",
          unit: "",
          key: "successRate",
        },
        {
          name: "ROI",
          data: "0:00",
          unit: "",
          key: "roi",
        },
      ],
      // 往日监控数据分析-均值
      calculateCuifuAvg: {},
      // 往日监控数据分析-汇总
      summaryDto: {},
      rangeCountList: [],
      total: 0,
      isShowAll: false,
      pageNum: 1,
      menuType: "",
      unitPriceView: false,
      pageSize: 10,
      tableParam: {
        orderIds: [],
        recordIds: []
      }
    };
  },
  filters: {
    //展开收缩
    overFloatContent(d, s) {
      try {
        if (!s) {
          return d.length <= 20 ? d : d.substr(0, 20) + "...";
        } else {
          return d;
        }
      } catch (e) {
        return "...";
      }
    },
    toPercentSign(percent) {
      var res = '';
      if (percent) {
        res = (percent * 100).toFixed(2) + '%'
      }
      return res;
    }
  },
  watch: {},
  computed: {
    // 获取定义在路由meta的信息
    taskTypeActive() {
      return this.$route.meta.taskType;
    },
    ...mapState({
      changeColor: "globalBG",
      roiTip: "roiTip",
      //   把city映射给currentCIty
    }),
  },
  created() {
    // 任务下拉框数据
    page({
      size: 1000,
      current: 1,
      taskType: this.taskTypeActive,
    }).then((res) => {
      this.options = res.data.records.map((i) => {
        return {
          label: i.taskName,
          value: i.id,
        };
      });
      // this.taskTableTotalCount = res.data.total
    });
  },
  mounted() {
    this.init();
    // this.drawLine();
    // 客户单价信息
    getSellerInfo().then((res) => {
      this.unitPriceValue = res.data.unitPrice;
    });
  },
  watch: {
    $route(to, from) {
      this.init();
    },
  },
  methods: {
    updateUnitPrice() {
      this.unitPriceView = false;
      updateUnitPrice(this.unitPriceValue).then((res) => {
        if (res.code === 1) {
          this.$message.success("修改成功");
        }
      });
    },
    // 初始化
    init() {
      this.getRemind();
      this.getRemindByTime();
    },
    // 获取今日数据
    getRemind() {
      this.todayLoading = true;
      data({
        ...this.type,
        remindType: this.taskTypeActive,
        dataType: 0,
      }).then(({ data }) => {
        this.todayLoading = false;
        this.todayData.map((item) => {
          item.data = data[0][item.key];
        });
      });
    },
    // 往日数据
    getRemindByTime() {
      this.talbeLoading = true;
      var rangeCountParams = JSON.parse(JSON.stringify(this.rangeCountParams));
      if (rangeCountParams.customTimeStart) {
        rangeCountParams.customTimeStart = rangeCountParams.customTimeStart.substr(0, 10);
      }
      if (rangeCountParams.customTimeEnd) {
        rangeCountParams.customTimeEnd = rangeCountParams.customTimeEnd.substr(0, 10);
      }

      let params = {
        ...rangeCountParams,
        ...this.type,
        remindType: this.taskTypeActive,
      };
      for (var i in params) {
        if (params[i] == "") {
          delete params[i];
        }
      }
      data(params).then(({ data }) => {
        this.talbeLoading = false;
        console.log(data);
        let dataArr = data.filter((item) => {
          return item.countTime != "avg" && item.countTime != "sum";
        });
        if (dataArr.length != 0) {
          let avg = data.filter((item) => {
            return item.countTime == "avg";
          });
          let sum = data.filter((item) => {
            return item.countTime == "sum";
          });
          // console.log(dataArr);
          // console.log(avg);
          // console.log(sum);
          this.rangeCountList = dataArr;
          this.calculateCuifuAvg = avg.lenght != 0 ? avg[0] : []; //均值
          this.summaryDto = sum.lenght != 0 ? sum[0] : []; // 汇总
          // 画图表
          if (this.selectIndex == 3) {
            this.drawLine();
          }
        } else {
          this.rangeCountList = [];
          this.calculateCuifuAvg = {}; //均值
          this.summaryDto = {}; // 汇总
          if (this.selectIndex == 3) {
            this.drawLine();
          }
        }
      });
    },
    taskAppoint(index) {
      // console.log(index);
      this.getRemind();
      this.getRemindByTime();
    },
    /**
     *搜索数据
     */
    seacherResultCare() {
      if (this.rangeCountParams.dataType === "3") {
        if (
          !this.rangeCountParams.customTimeStart ||
          !this.rangeCountParams.customTimeEnd
        ) {
          this.$message.info("请选择时间");
          return;
        }
      }
      this.getRemindByTime();
    },
    // 往日数据日期单选事件
    selectTimeRange() {
      if (this.rangeCountParams.dataType === "3") {
        // 自定义
        this.timeRangeView = false;
      } else {
        this.timeRangeView = true;
        this.rangeCountParams.customTimeStart = "";
        this.rangeCountParams.customTimeEnd = "";
      }
    },
    // 分析类型单选事件
    selectType() {
      console.log(this.type.label);
      if (this.type.analysisType === "1") {
        this.typeView = false;
      } else {
        this.typeView = true;
        this.type.value = "";
      }
    },
    returnOrderNum(item, type) {
      console.log(item, type);
      this.pageNum = 1;
      this.countTime = item.countTime;
      this.tableParam = {
        orderIds: item['orderIds'] || [],
        recordIds: item['recordIds'] || [],
      }
      // return;
      this._getPaymentInfoList(type);
      this.returnOrderDialog = true;
    },
    handleCurrentChange(v) {
      this.pageNum = v;
      this._getPaymentInfoList();
    },
    handleSizeChange(v) {
      this.pageSize = v;
      this.pageNum = 1
      this._getPaymentInfoList();
    },
    _getPaymentInfoList(type) {
      this.orderLoading = true;
      let params = {
        ...this.type,
        ...this.rangeCountParams,

        size: this.pageSize,
        current: this.pageNum,
        remindType: this.taskTypeActive,
      };
      if (type == 1) {
        params.countTime = this.countTime;
      }
      params['orderIds'] = this.tableParam.orderIds;
      params['recordIds'] = this.tableParam.recordIds;
      orderQuery(params).then((res) => {
        this.orderLoading = false;
        this.orderData = res.data.records;
        this.total = res.data.total;
      });
    },
    isShowTextAll() {
      this.isShowAll = !this.isShowAll;
    },
    // isInMonth() {
    //     console.log(this.rangeCountParams.endTime);
    //     if (
    //     Math.abs(
    //         new Date().getTime() -
    //         new Date(this.rangeCountParams.endTime).getTime()
    //     ) >
    //     30 * 24 * 60 * 60 * 1000
    //     ) {
    //     this.rangeCountParams.endTime = moment(new Date()).format(
    //         "YYYY-MM-DD HH:mm:ss"
    //     );
    //     }
    //     if (
    //     Math.abs(
    //         new Date().getTime() -
    //         new Date(this.rangeCountParams.startTime).getTime()
    //     ) >
    //     30 * 24 * 60 * 60 * 1000
    //     ) {
    //     this.rangeCountParams.startTime = moment(
    //         new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000)
    //     ).format("YYYY-MM-DD HH:mm:ss");
    //     }
    // },
    // 重置日期
    clearTime() {
      this.rangeCountParams.customTimeStart = "";
      this.rangeCountParams.customTimeEnd = "";
    },
    // 重置查询条件
    resetBtn() {
      this.rangeCountParams = {
        dataType: "2",
        startTime: "",
        endTime: "",
      };
      this.getRemindByTime();
    },
    // 折线图-画线
    drawLine() {
      console.log("开始画线==");
      let self = this;
      const rangeCountList = this.rangeCountList;
      let [dateList, orderPaymentList, successCountList, orderCountList] = [
        [],
        [],
        [],
        [],
      ];
      // if (this.asideActive == 18) {
      //   rangeCountList.forEach(function(item) {
      //     dateList.push(item.subTime); //日期
      //     orderPaymentList.push(item.orderPayment); //挽回金额
      //     orderPayedCountList.push(item.count); //挽回订单数
      //     recordCountList.push(item.recordCount); //催付订单数
      //   });
      // } else if (this.asideActive == 15) {
      //   rangeCountList.forEach(function(item) {
      //     dateList.push(item.subTime); //日期
      //     orderPaymentList.push(item.recordCount); //签收提醒数
      //     orderPayedCountList.push(item.count); //催评成功数
      //     recordCountList.push(item.manualTakeGoodsOrderCount); //主动确认收货数
      //   });
      // } else {
      //   rangeCountList.forEach(function(item) {
      //     dateList.push(item.subTime); //日期
      //     orderPaymentList.push(item.orderPayment); //挽回金额
      //     orderPayedCountList.push(item.orderPayedCount); //挽回订单数
      //     recordCountList.push(item.recordCount); //催付订单数
      //   });
      // }
      rangeCountList.forEach(function (item) {
        dateList.push(item.countTime); //日期
        orderCountList.push(item.orderCount); //下单数
        successCountList.push(item.dealOrderCount); //成交订单数
        orderPaymentList.push(item.dealAmount); //成交金额
      });

      // 催付订单数 挽回订单 挽回金额 日期
      let yAxisName;
      let seriesItem = [];
      let legendDatas = [];
      yAxisName = "";
      seriesItem = [
        {
          name: "下单数",
          data: orderCountList,
          type: "line",
          smooth: true,
          color: ["#FE4D45"],
        },
        {
          name: "成交订单数",
          data: successCountList,
          type: "line",
          smooth: true,
          color: ["#4878FF"],
        },
        {
          name: "成交金额",
          data: orderPaymentList,
          type: "line",
          smooth: true,
          color: ["#49C568"],
        },
      ];
      legendDatas = ["下单数", "成交订单数", "成交金额"];
      // }

      self.$nextTick(() => {
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(
          document.getElementById("myChart"),
          "light"
        );
        // 绘制图表
        window.onresize = myChart.resize;
        myChart.setOption({
          legend: {
            data: legendDatas,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
          xAxis: {
            name: "日期",
            type: "category",
            data: dateList,
            axisLine: {
              lineStyle: {
                color: "#838383",
              },
            },
          },
          yAxis: {
            name: yAxisName,
            type: "value",
            axisLine: {
              lineStyle: {
                color: "#666666",
              },
            },
            axisLine: {
              //y轴
              show: false,
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            splitLine: {
              //网格线
              show: true,
              color: "#999",
            },
          },
          series: seriesItem,
        });
      });
    },
  },
};
</script>
<style  lang="scss" scoped>
.return-order-com {
  .exportBtn {
    height: 30px;
    float: right;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: middle;
    padding: 0px 12px;
    border: 1px solid #2062e7;
    color: #2062e7;
    font-size: 16px;
    line-height: 25px;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    margin-right: 15px;
    cursor: pointer;
    .button-icon {
      display: inline-block;
      vertical-align: middle;
      margin-right: 8px;
    }
    .button-title {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .export_btn2 {
    width: 32px;
    height: 32px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(204, 204, 204, 1);
    opacity: 1;
    border-radius: 4px;
    margin-right: 2px;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
    float: right;
  }
  .up-date {
    height: 32px;
    line-height: 32px;
  }
}
</style>
<style lang='scss' scoped>
.market_analysis {
  .main_content {
    .status_btn {
      width: 98px;
      // height: 32px;
      background-color: #fff;
      font-size: 14px;
    }
    .status_btn3 {
      margin-left: 8px;
      vertical-align: middle;
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff;
      &:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
    }
    .status_btn4 {
      margin-left: 12px;
      vertical-align: middle;
      color: #666666;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .question_icon {
      width: 14px;
      height: 14px;
      color: #ccc;
      display: inline-block;
      line-height: 12px;
      text-align: center;
      border-radius: 14px;
      border: 1px solid #ccc;
      font-size: 12px;
      font-weight: normal;
    }
    .analysis_type {
      margin-bottom: 20px;
    }
    .data_today {
      .today_item {
        display: inline-block;
        padding-left: 40px;
        border-left: 1px solid #f0f0f0;
        width: 16.66%;
        position: relative;
        margin-bottom: 32px;
      }
      .today_item:first-child {
        border-left: 0px;
      }
      .data_name {
        height: 20px;
        font-size: 14px;
        /* font-family: PingFang SC; */
        font-weight: 400;
        line-height: 20px;
        color: rgba(153, 153, 153, 1);
        opacity: 1;
        display: inline-block;
        margin: 3px 0 8px;
      }
      .data_num {
        height: 29px;
        font-size: 24px;
        // font-family: SF Pro Display;
        font-weight: 400;
        line-height: 29px;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 4px;
      }
      .data_num_unit {
        margin-left: 4px;
        height: 20px;
        font-size: 14px;
        /* font-family: PingFang SC; */
        font-weight: 400;
        line-height: 20px;
        display: inline-block;
      }
      .edit_price {
        width: 56px;
        height: 20px;
        font-size: 14px;
        // font-family:PingFang SC;
        font-weight: 400;
        line-height: 20px;
        color: rgba(254, 77, 69, 1);
        opacity: 1;
        position: absolute;
        top: 3px;
        left: 89px;
        cursor: pointer;
      }
    }
    .title {
      height: 22px;
      font-size: 16px;
      /* font-family: PingFang SC; */
      font-weight: 500;
      line-height: 22px;
      color: rgba(254, 77, 69, 1);
      margin-bottom: 20px;
      .line {
        width: 4px;
        margin-top: -4px;
        height: 14px;
        background: rgba(254, 77, 69, 1);
        opacity: 1;
        display: inline-block;
        margin-right: 6px;
        vertical-align: middle;
      }
    }
  }
  .my_chart {
    margin-top: 40px;
  }
}
</style>